export default __webpack_public_path__ + "static/Introduction-to-CFM-Loop-360p-45eaa1fbc1703f102336fe120bd11be0.webm";